import { render, staticRenderFns } from "./pshareaward.vue?vue&type=template&id=003b2840&scoped=true&"
import script from "./pshareaward.vue?vue&type=script&lang=js&"
export * from "./pshareaward.vue?vue&type=script&lang=js&"
import style0 from "./pshareaward.vue?vue&type=style&index=0&id=003b2840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003b2840",
  null
  
)

export default component.exports